import { useEffect, useState } from "react";
import { Plus, Archive } from "@phosphor-icons/react";
import { toast } from "sonner";
import api from "../lib/api";

export default function CategoriesTags() {
  const [tab, setTab] = useState("categories");
  const [lookups, setLookups] = useState(null);
  const [name, setName] = useState("");
  const [kind, setKind] = useState("expense");

  const load = () => api.get("/lookups").then((r) => setLookups(r.data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!name.trim()) return toast.error("Name required");
    try {
      if (tab === "categories") await api.post("/categories", { name: name.trim(), category_kind: kind });
      else await api.post("/tags", { name: name.trim() });
      setName("");
      toast.success("Added");
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not add");
    }
  };

  const archive = async (id) => {
    try {
      await api.delete(`/${tab === "categories" ? "categories" : "tags"}/${id}`);
      toast.success(tab === "categories" ? "Deleted" : "Archived");
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not delete");
    }
  };

  const items = tab === "categories" ? (lookups?.categories || []) : (lookups?.tags || []);

  return (
    <div className="px-5 pt-8" data-testid="categories-page">
      <h1 className="text-2xl font-heading font-bold tracking-tight">Categories & Tags</h1>
      <div className="mt-4 flex rounded-xl bg-secondary p-1">
        {["categories", "tags"].map((t) => (
          <button key={t} data-testid={`cat-tab-${t}`} onClick={() => setTab(t)} className={`flex-1 h-10 rounded-lg text-sm font-medium capitalize ${tab === t ? "bg-white shadow-sm" : "text-muted-foreground"}`}>{t}</button>
        ))}
      </div>

      <div className="mt-4 bg-white border border-border rounded-2xl p-4 space-y-2">
        <div className="flex gap-2">
          <input data-testid="cat-add-name" className="flex-1 h-12 px-4 rounded-xl bg-background border border-border" placeholder={`New ${tab === "categories" ? "category" : "tag"} name`} value={name} onChange={(e) => setName(e.target.value)} />
          <button data-testid="cat-add-btn" onClick={add} className="h-12 w-12 rounded-xl bg-primary text-primary-foreground flex items-center justify-center"><Plus size={18} /></button>
        </div>
        {tab === "categories" && (
          <div className="flex gap-2">
            {["expense", "income"].map((k) => (
              <button key={k} data-testid={`cat-kind-${k}`} onClick={() => setKind(k)} className={`h-9 px-4 rounded-full text-xs font-medium border capitalize ${kind === k ? "bg-primary text-primary-foreground border-primary" : "bg-background border-border"}`}>{k}</button>
            ))}
          </div>
        )}
      </div>

      <div className="mt-4 bg-white border border-border rounded-2xl overflow-hidden mb-6">
        {items.map((it) => (
          <div key={it.id} className="flex items-center gap-3 px-4 py-3 border-b border-border last:border-0">
            {tab === "tags" && <span className="h-3 w-3 rounded-full shrink-0" style={{ background: it.color }} />}
            <span className="flex-1 text-sm font-medium">{it.name}</span>
            {tab === "categories" && <span className="text-[11px] px-2 py-0.5 rounded-full bg-secondary text-muted-foreground capitalize">{it.category_kind}</span>}
            <button data-testid={`cat-archive-${it.id}`} onClick={() => archive(it.id)} className="h-10 w-10 flex items-center justify-center rounded-xl text-muted-foreground active:bg-secondary"><Archive size={16} /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
